import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ToastController } from '@ionic/angular';

@Component({
  selector: 'app-customer-forgot-password',
  templateUrl: './customer-forgot-password.page.html',
  styleUrls: ['./customer-forgot-password.page.scss'],
})

export class CustomerForgotPasswordPage implements OnInit {
  formGroup: FormGroup;
  message = '';
  forgot_password:boolean = true;
  success_page:boolean = false;
  invalidEmail=false;

  constructor(
    private _fb: FormBuilder, 
    private router:Router, 
    private authService:AuthService,
    public toastController: ToastController,
  ) {
    this.formGroup = this._fb.group({
      email: ['', Validators.compose([Validators.required])]
    });
  }

  get f() {
    return this.formGroup.controls;
  }

  ionViewWillEnter(){
    this.formGroup.reset();
  }
  
  ngOnInit() {
  }

  forgotPassword(){
    let email = this.formGroup.get('email').value.trim().toLowerCase();
    let regexp = new RegExp(/^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9-]+)*$/);
    regexp.test(email);
    this.invalidEmail =false;
    if (!regexp.test(email)){
      this.invalidEmail =true;
      return false;
    }
    let user={
      email: email
    }
    this.authService.forgotPassword(user).subscribe( 
      response => {
        if(response.status == 200){
          this.message = response.message;        
          this.forgot_password = false;
          this.success_page = true;
        }else{
          this.presentToast(response.error.error.message);
          this.forgot_password = true;
          this.success_page = false;
        }
      },
      error => {
        this.forgot_password = true;
        this.success_page = false;
        this.message = error.error.message;
      }
    );    
  }

  async presentToast(error_msg) {
    const toast = await this.toastController.create({
      message: error_msg,
      duration: 2000
    });
    toast.present();
  }

  onloginPage(){
    this.router.navigate(['customer-login']);
  }

  backPage(){
    this.router.navigate(['customer-login']);
  }

  backHome(){
    this.router.navigate(['home']);
  }
}

